import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styleSheet"];
import React from 'react';
import { compose, setDisplayName } from 'recompose';
import omitProps from '@hocs/omit-props';
import wrapOverridableComponent from '@bubble-ui/hoc-wrap-overridable-component';
import Shape from '@bubble-ui/primitive-shape';
import Surface from '@bubble-ui/primitive-surface';

var getDefaultStyleSheet = function getDefaultStyleSheet(_ref) {
  var color = _ref.color;
  return {
    pathStyle: {
      fill: color
    }
  };
};

var WarningWrapper = function WarningWrapper(_ref2) {
  var pathStyle = _ref2.styleSheet.pathStyle,
      props = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/React.createElement(Surface, _extends({
    height: 20,
    width: 20
  }, props), /*#__PURE__*/React.createElement(Shape, _extends({
    d: "M1.7984713,17.676 L0,17.025 L0.570515062,15.198 C1.33686367,12.747 2.39996003,10.375 3.7308288,8.15 C5.07868312,5.893 6.7072988,3.78 8.57071489,1.873 L9.99950042,0.41 L11.428286,1.873 C13.2907029,3.779 14.9203177,5.891 16.2691712,8.15 C17.60004,10.375 18.6631363,12.747 19.4284858,15.198 L20,17.026 L18.2005295,17.676 C15.5947445,18.619 12.7961233,19.09 9.99850127,19.09 C7.20087925,19.09 4.40325723,18.619 1.7984713,17.676 Z"
  }, pathStyle)));
};

export default compose(setDisplayName('FeedbackStateIconWarningWrapper'), wrapOverridableComponent('FeedbackStateIconWarningWrapper', getDefaultStyleSheet), omitProps('color', 'designVersion'))(WarningWrapper);
//# sourceMappingURL=index.js.map